import * as i0 from '@angular/core';
import { Directive, inject, ChangeDetectorRef, EventEmitter, Component, ChangeDetectionStrategy, ContentChild, Input, Output, DestroyRef, ContentChildren } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EMPTY_QUERY } from '@taiga-ui/cdk/constants';
import { tuiQueryListChanges } from '@taiga-ui/cdk/observables';
import { tuiIsPresent } from '@taiga-ui/cdk/utils/miscellaneous';
import * as i1$1 from '@taiga-ui/core/directives/group';
import { TuiGroup } from '@taiga-ui/core/directives/group';
import { pairwise, map, filter, merge, switchMap, identity } from 'rxjs';
import { NgIf } from '@angular/common';
import * as i1 from '@taiga-ui/core/components/expand';
import { TuiExpand } from '@taiga-ui/core/components/expand';
import { TuiIcon } from '@taiga-ui/core/components/icon';
import { TuiChevron } from '@taiga-ui/kit/directives';
import { PolymorpheusTemplate, PolymorpheusOutlet } from '@taiga-ui/polymorpheus';
const _c0 = ["*", [["", "tuiAccordionItemContent", "", 5, "ng-template"]]];
const _c1 = ["*", "[tuiAccordionItemContent]:not(ng-template)"];
function TuiAccordionItem_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "tui-icon", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tuiChevron", ctx_r0.open);
  }
}
function TuiAccordionItem_ng_template_6_div_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const text_r2 = ctx.polymorpheusOutlet;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", text_r2, " ");
  }
}
function TuiAccordionItem_ng_template_6_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, TuiAccordionItem_ng_template_6_div_0_ng_container_1_Template, 2, 1, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r0.lazyContent);
  }
}
function TuiAccordionItem_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TuiAccordionItem_ng_template_6_div_0_Template, 2, 1, "div", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.lazyContent);
  }
}
function TuiAccordionItem_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
let TuiAccordionItemContent = /*#__PURE__*/(() => {
  class TuiAccordionItemContent extends PolymorpheusTemplate {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTuiAccordionItemContent_BaseFactory;
        return function TuiAccordionItemContent_Factory(__ngFactoryType__) {
          return (ɵTuiAccordionItemContent_BaseFactory || (ɵTuiAccordionItemContent_BaseFactory = i0.ɵɵgetInheritedFactory(TuiAccordionItemContent)))(__ngFactoryType__ || TuiAccordionItemContent);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiAccordionItemContent,
        selectors: [["ng-template", "tuiAccordionItemContent", ""]],
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return TuiAccordionItemContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiAccordionItemEagerContent = /*#__PURE__*/(() => {
  class TuiAccordionItemEagerContent {
    static {
      this.ɵfac = function TuiAccordionItemEagerContent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiAccordionItemEagerContent)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiAccordionItemEagerContent,
        selectors: [["", "tuiAccordionItemContent", "", 5, "ng-template"]]
      });
    }
  }
  return TuiAccordionItemEagerContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiAccordionItem = /*#__PURE__*/(() => {
  class TuiAccordionItem {
    constructor() {
      this.cdr = inject(ChangeDetectorRef);
      this.noPadding = false;
      this.showArrow = true;
      this.borders = 'all';
      this.size = 'm';
      this.disabled = false;
      this.disableHover = false;
      this.open = false;
      this.async = false;
      this.openChange = new EventEmitter();
    }
    close() {
      this.updateOpen(false);
      this.cdr.markForCheck();
    }
    onRowToggle() {
      if (!this.disabled) {
        this.updateOpen(!this.open);
      }
    }
    onItemKeyDownEsc(event) {
      if (!this.open) {
        return;
      }
      event.stopPropagation();
      this.updateOpen(false);
    }
    updateOpen(open) {
      if (this.open === open) {
        return;
      }
      this.open = open;
      this.openChange.emit(open);
    }
    static {
      this.ɵfac = function TuiAccordionItem_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiAccordionItem)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiAccordionItem,
        selectors: [["tui-accordion-item"]],
        contentQueries: function TuiAccordionItem_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TuiAccordionItemEagerContent, 5);
            i0.ɵɵcontentQuery(dirIndex, TuiAccordionItemContent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.eagerContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.lazyContent = _t.first);
          }
        },
        hostVars: 8,
        hostBindings: function TuiAccordionItem_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-borders", ctx.borders)("data-size", ctx.size);
            i0.ɵɵclassProp("_no-padding", ctx.noPadding)("_has-arrow", ctx.showArrow)("_disabled", ctx.disabled);
          }
        },
        inputs: {
          noPadding: "noPadding",
          showArrow: "showArrow",
          borders: "borders",
          size: "size",
          disabled: "disabled",
          disableHover: "disableHover",
          open: "open",
          async: "async"
        },
        outputs: {
          openChange: "openChange"
        },
        ngContentSelectors: _c1,
        decls: 8,
        vars: 9,
        consts: [["automation-id", "tui-accordion__item-wrapper", 1, "t-wrapper"], ["automation-id", "tui-accordion__item-header", "type", "button", 1, "t-header", 3, "click", "keydown.esc", "disabled"], ["automation-id", "tui-accordion__item-title", 1, "t-title"], [4, "ngIf"], [3, "async", "expanded"], ["tuiExpandContent", ""], ["class", "t-content", 4, "ngIf"], [1, "t-icon", 3, "tuiChevron"], ["automation-id", "tui-accordion__item-content", "class", "t-content", 4, "ngIf"], ["automation-id", "tui-accordion__item-content", 1, "t-content"], [4, "polymorpheusOutlet"], [1, "t-content"]],
        template: function TuiAccordionItem_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function TuiAccordionItem_Template_button_click_1_listener() {
              return ctx.onRowToggle();
            })("keydown.esc", function TuiAccordionItem_Template_button_keydown_esc_1_listener($event) {
              return ctx.onItemKeyDownEsc($event);
            });
            i0.ɵɵelementStart(2, "span", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, TuiAccordionItem_ng_container_4_Template, 2, 1, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "tui-expand", 4);
            i0.ɵɵtemplate(6, TuiAccordionItem_ng_template_6_Template, 1, 1, "ng-template", 5)(7, TuiAccordionItem_div_7_Template, 2, 0, "div", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassProp("t-header_hoverable", !ctx.disableHover)("t-header_open", ctx.open);
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showArrow);
            i0.ɵɵadvance();
            i0.ɵɵproperty("async", ctx.async)("expanded", ctx.open);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.eagerContent);
          }
        },
        dependencies: [NgIf, PolymorpheusOutlet, TuiChevron, i1.TuiExpandComponent, i1.TuiExpandContent, TuiIcon],
        styles: ["[_nghost-%COMP%]{position:relative;display:block;overflow:hidden;border-radius:var(--tui-radius-l)}[data-borders=top-bottom][_nghost-%COMP%]{border-radius:0!important}  tui-accordion{inline-size:100%}.t-wrapper[_ngcontent-%COMP%]{position:relative;border-radius:inherit}.t-wrapper[_ngcontent-%COMP%]:after{position:absolute;top:0;left:0;inline-size:100%;block-size:100%;content:\"\";box-sizing:border-box;border-radius:inherit;border:1px solid var(--tui-border-normal);pointer-events:none}[_nghost-%COMP%]:not([data-borders])   .t-wrapper[_ngcontent-%COMP%]:after{border-width:0}[data-borders=all][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]:after{border-width:1px}[data-borders=top-bottom][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]:after{border-inline-start-width:0;border-inline-end-width:0}[data-borders=top][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]:after{border-inline-start-width:0;border-inline-end-width:0;border-block-end-width:0}[data-borders=bottom][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]:after{border-inline-start-width:0;border-inline-end-width:0;border-block-start-width:0}.t-header[_ngcontent-%COMP%]{-webkit-appearance:none;appearance:none;padding:0;border:0;background:none;font:inherit;line-height:inherit;text-decoration:none;transition-property:background;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;display:flex;inline-size:100%;font:var(--tui-font-text-l);align-items:center;box-sizing:border-box;border-block-end:1px solid var(--tui-border-normal);min-block-size:var(--tui-height-l);padding:.75rem 1.25rem;color:var(--tui-text-primary);cursor:pointer;text-align:start;outline:none}.t-header[_ngcontent-%COMP%]:focus-visible{box-shadow:inset 0 0 0 2px var(--tui-border-focus)}[_nghost-%COMP%]:not([data-borders])   .t-header[_ngcontent-%COMP%]{border-block-end-width:0}._has-arrow[_nghost-%COMP%]   .t-header[_ngcontent-%COMP%]{padding-right:.75rem}[tuiTheme=\"dark\"][_nghost-%COMP%]   .t-header_open[_ngcontent-%COMP%], [tuiTheme=\"dark\"]   [_nghost-%COMP%]   .t-header_open[_ngcontent-%COMP%]{background:var(--tui-background-neutral-1)}[data-size=s][_nghost-%COMP%]   .t-header[_ngcontent-%COMP%]{font:var(--tui-font-text-m);min-block-size:var(--tui-height-m);padding:.625rem .75rem .625rem 1rem}._no-padding[_nghost-%COMP%]   .t-header[_ngcontent-%COMP%]{padding-left:0;padding-right:0}._disabled[_nghost-%COMP%]   .t-header[_ngcontent-%COMP%]{cursor:default}.t-wrapper[_ngcontent-%COMP%]:hover > .t-header_hoverable[_ngcontent-%COMP%]{background:var(--tui-background-base-alt)}.t-title[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-right:0;flex-grow:1}._has-arrow[_nghost-%COMP%]   .t-title[_ngcontent-%COMP%]{margin-right:.5rem}.t-icon[_ngcontent-%COMP%]{transition-property:color;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;margin-left:auto;border-width:.25rem;color:var(--tui-text-tertiary)}[_nghost-%COMP%]:hover   .t-icon[_ngcontent-%COMP%]{color:var(--tui-text-secondary)}.t-content[_ngcontent-%COMP%]{font:var(--tui-font-text-m);padding:1.25rem;overflow-wrap:break-word}[data-size=s][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{font:var(--tui-font-text-s);padding:1rem}"],
        changeDetection: 0
      });
    }
  }
  return TuiAccordionItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiAccordionDirective = /*#__PURE__*/(() => {
  class TuiAccordionDirective {
    constructor() {
      this.destroyRef = inject(DestroyRef);
      this.accordionItems = EMPTY_QUERY;
      this.closeOthers = true;
      // Not using DI options to avoid changed defaults spilling to content
      const group = inject(TuiGroup);
      group.orientation = 'vertical';
      group.collapsed = true;
    }
    ngAfterContentInit() {
      const {
        accordionItems
      } = this;
      const rows$ = tuiQueryListChanges(accordionItems);
      const newOpenRow$ = rows$.pipe(pairwise(), map(([previous, current]) => current.find(item => !previous.includes(item) && item.open)), filter(tuiIsPresent));
      const rowsOpen$ = merge(rows$.pipe(switchMap(rows => merge(...rows.map(row => row.openChange.pipe(filter(identity), map(() => row)))))), newOpenRow$).pipe(filter(() => this.closeOthers), takeUntilDestroyed(this.destroyRef));
      rowsOpen$.subscribe(currentRow => {
        accordionItems.forEach(row => {
          if (currentRow !== row) {
            row.close();
          }
        });
      });
    }
    static {
      this.ɵfac = function TuiAccordionDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiAccordionDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiAccordionDirective,
        selectors: [["tui-accordion"]],
        contentQueries: function TuiAccordionDirective_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TuiAccordionItem, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordionItems = _t);
          }
        },
        inputs: {
          closeOthers: "closeOthers"
        },
        features: [i0.ɵɵHostDirectivesFeature([{
          directive: i1$1.TuiGroup,
          inputs: ["rounded", "rounded"]
        }])]
      });
    }
  }
  return TuiAccordionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TuiAccordion = [TuiAccordionItem, TuiAccordionDirective, TuiAccordionItemContent, TuiAccordionItemEagerContent];

/**
 * Generated bundle index. Do not edit.
 */

export { TuiAccordion, TuiAccordionDirective, TuiAccordionItem, TuiAccordionItemContent, TuiAccordionItemEagerContent };
